module.exports = "    <div class=\"cardup\">\r\n        <h3>{{title}} BLSA</h3>\r\n    </div>\r\n    <div [id]=\"donutChartWrapperId\" class=\"cardon\">\r\n        <div [id]=\"donutChartId\"></div>\r\n    </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowDonutChart.component.html
// module id = 1163
// module chunks = 2